import { Switch, styled } from '@mui/material';
import KillSwitchIcon from '@shared/assets/killSwitch.png';

export const KillSwitchButton = styled(Switch)(({ checked }) => ({
  width: 62,
  height: 34,
  padding: 7,

  '& .MuiSwitch-switchBase': {
    margin: 1,

    padding: 0,
    transform: 'translateX(0px)',
    transition: 'all 0.2s ease',
    '&.Mui-checked': {
      transform: 'translateX(22px)',
      animation: 'spin 4s linear infinite',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: 'hsla(50, 100%, 60%, 1.00)',
        borderRadius: 20 / 2,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: checked ? 'hsla(50, 100%, 50%, 1.00)' : 'white',
    width: 32,
    height: 32,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '100%',
    backgroundImage: `url(${KillSwitchIcon})`,
    transition: 'all 0.2s ease',
    '@keyframes spin': {
      '0%': { transform: 'translate(22px) rotate(0deg) ' },
      '100%': { transform: 'translate(22px) rotate(360deg) ' },
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: '#b4b4b4ff',
    borderRadius: 20 / 2,
  },
}));
